"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const create_note_dto_1 = require("./dto/create-note.dto");
const get_note_dto_1 = require("./dto/get-note.dto");
const update_note_dto_1 = require("./dto/update-note.dto");
const note_service_1 = require("./note.service");
const note_swagger_1 = require("./note.swagger");
let NoteController = class NoteController {
    constructor(noteService) {
        this.noteService = noteService;
    }
    // Create a new note
    async createNote(noteData, res, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            noteData.createdBy = userId;
            noteData.updatedBy = userId;
            const note = await this.noteService.createNote(noteData);
            return res
                .status(common_1.HttpStatus.CREATED)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.CREATED, messages_1.successMessage.noteCreation, note));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, error.message || messages_1.errorMessages.noteNotFound, messages_1.infoMessages.forBidden, messages_1.errorMessages.noteCreationFailed);
        }
    }
    // Get notes with pagination, search, and sorting
    async getNotes(query, res, req) {
        try {
            const { page, limit, search, sort, searchBy } = query;
            const userId = parseInt(req?.headers?.userid);
            const notes = await this.noteService.getNotes(page || constants_1.DEFAULT_PAGE, limit || constants_1.DEFAULT_LIMIT, search || "", sort || "createdAt:DESC", userId, searchBy || "");
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.noteList, notes));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, error.message, messages_1.infoMessages.forBidden, messages_1.errorMessages.noteListRetrievalFailed);
        }
    }
    // Get a note by ID
    async getNoteById(id, res) {
        try {
            const note = await this.noteService.getNoteById(id);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.noteDetails, note));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, messages_1.errorMessages.noteNotFound, messages_1.infoMessages.forBidden, messages_1.errorMessages.noteDetailsRetrievalFailed);
        }
    }
    // Update a note by ID
    async updateNoteById(id, updateNote, res, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            updateNote.updatedBy = userId;
            const note = await this.noteService.updateNoteById(id, updateNote);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.noteUpdate, note));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, error.message || messages_1.errorMessages.noteNotFound, messages_1.infoMessages.forBidden, messages_1.errorMessages.noteUpdateFailed);
        }
    }
    // Delete a note by ID
    async deleteNoteById(id, res) {
        try {
            await this.noteService.deleteNoteById(id);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.noteDeleted, null));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, messages_1.errorMessages.noteNotFound, messages_1.infoMessages.forBidden, messages_1.errorMessages.noteDeletionFailed);
        }
    }
};
exports.NoteController = NoteController;
tslib_1.__decorate([
    (0, common_1.Post)(),
    (0, note_swagger_1.createNoteSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_b = typeof create_note_dto_1.CreateNoteDto !== "undefined" && create_note_dto_1.CreateNoteDto) === "function" ? _b : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], NoteController.prototype, "createNote", null);
tslib_1.__decorate([
    (0, common_1.Get)(),
    (0, note_swagger_1.getNotesSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Query)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_c = typeof get_note_dto_1.GetNotesDto !== "undefined" && get_note_dto_1.GetNotesDto) === "function" ? _c : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], NoteController.prototype, "getNotes", null);
tslib_1.__decorate([
    (0, common_1.Get)(":id"),
    (0, note_swagger_1.getNoteByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("id")),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], NoteController.prototype, "getNoteById", null);
tslib_1.__decorate([
    (0, common_1.Put)(":id"),
    (0, note_swagger_1.updateNoteSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("id")),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__param(3, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_d = typeof update_note_dto_1.UpdateNoteDto !== "undefined" && update_note_dto_1.UpdateNoteDto) === "function" ? _d : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], NoteController.prototype, "updateNoteById", null);
tslib_1.__decorate([
    (0, common_1.Delete)(":id"),
    (0, note_swagger_1.deleteNoteSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("id")),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], NoteController.prototype, "deleteNoteById", null);
exports.NoteController = NoteController = tslib_1.__decorate([
    (0, common_1.Controller)("note"),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof note_service_1.NoteService !== "undefined" && note_service_1.NoteService) === "function" ? _a : Object])
], NoteController);
